<template>
  <widget
    @closed="$emit('closed')"
    @search="toggleSearch"
    title="Assenze e presenze lavoratori"
    icon="mdi-account-group"
    dark
    :bgColor="colors.orange"
    searchButton
    scroll
  >
    <transition name="fade" appear>
      <v-row v-if="searchBtn" class="px-3 py-0 ma-0 search-bar">
        <!--<v-col cols="12" class="pa-0 ma-0 mt-5">
          <search-bar @search="updateData"></search-bar>
        </v-col>-->
        <v-col cols="12" class="pa-0 ma-0">
          <v-text-field
            v-model="search"
            class="mx-1"
            label="Ricerca rapida"
            clearable
          ></v-text-field>          
        </v-col>
      </v-row>
    </transition>
    <v-list dense>
      <v-list-group
        no-action
        v-for="(item, index) in filteredList"
        :key="index"
      >
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-avatar size="20" :color="getColor(getIniziali(item))">
              <div
                class="white--text text-little text-center text-uppercase"
                style="width: 100%"
              >
                {{ getIniziali(item) }}
              </div>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-caption text-capitalize box-name">
                {{ item.cognome }} {{ item.nome }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <div>
                <v-divider></v-divider>
                <v-card-text class="text-no-wrap">
                  <v-row no-gutters>
                    <v-col cols="6">
                      <v-row no-gutters>
                        <v-col cols="12">
                          <v-card flat tile>
                            <div class="text-caption text-center title">
                              Assenze/presenze
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="12">
                          <v-card outlined flat tile>
                            <div class="text-center head text-truncate">
                              {{ item.mese }} {{ item.anno }}
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="8">
                          <v-card
                            outlined
                            flat
                            tile
                            class="px-1 text-caption text-truncate"
                          >
                            Lavorate ore
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card
                            outlined
                            flat
                            tile
                            class="px-1 text-caption"
                            >{{ item.presenze.lavorate }}</v-card
                          >
                        </v-col>
                        <v-col cols="8">
                          <v-card
                            outlined
                            flat
                            tile
                            class="px-1 text-truncate text-caption"
                            >Straordinario ore</v-card
                          >
                        </v-col>
                        <v-col cols="4">
                          <v-card
                            outlined
                            flat
                            tile
                            class="px-1 text-caption"
                            >{{ item.presenze.straordinario }}</v-card
                          >
                        </v-col>
                        <v-col cols="8">
                          <v-card
                            outlined
                            flat
                            tile
                            class="px-1 text-truncate text-caption"
                            >Assenze ore</v-card
                          >
                        </v-col>
                        <v-col cols="4">
                          <v-card
                            outlined
                            flat
                            tile
                            class="px-1 text-caption"
                            >{{ item.assenze.totale }}</v-card
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <v-row no-gutters>
                        <v-col cols="12">
                          <v-card flat tile>
                            <div class="text-caption text-center title">
                              Dettaglio assenze
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="12">
                          <v-card outlined flat tile>
                            <div class="text-center head text-caption">
                              {{ item.mese }} {{ item.anno }}
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row
                        no-gutters
                        v-for="d in item.assenze.dettaglio"
                        :key="d.codLegenda"
                      >
                        <v-col cols="8">
                          <v-card
                            outlined
                            flat
                            tile
                            class="px-1 text-caption"
                            >{{ d.descrizione }}</v-card
                          >
                        </v-col>
                        <v-col cols="4">
                          <v-card
                            outlined
                            flat
                            tile
                            class="px-1 text-caption"
                            >{{ d.ore }}</v-card
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
  </widget>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Widget from "./Widget.vue";
import mixin from "@/mixin";
//import SearchBar from "./SearchBar.vue";

export default {
  name: "assenze-presenze-lavoratori-home-widget",
  mixins: [mixin],
  components: {
    Widget,
    //SearchBar
  },
  mounted() {
    this.fetchData();
  },
  destroyed() {
    this.resetData();
  },
  data() {
    return {
      searchBtn: false,
      search: "",
    };
  },
  methods: {
      updateData(da, a) {
      this.fetchData({ da, a });
    },
    toggleSearch() {
      this.searchBtn = !this.searchBtn;
    },
    ...mapActions({
      fetchData: "widget/fetchPresenceAbsenceEmployees",
      resetData: "widget/resetPresenceAbsenceEmployees",
    }),
  },
  computed: {
    ...mapGetters({
      items: "widget/presenceAbsenceEmployees",
    }),
    filteredList() {
      return this.search
        ? this.items.filter((item) => {
            return `${item.nome}${item.cognome}${item.nome}${item.cognome}`
              .trim()
              .toLowerCase()
              .includes(this.search.toLowerCase().replace(" ", "").trim());
          })
        : this.items;
    },
  },
};
</script>

<style scoped>
.space {
  padding: 0px !important;
  margin: 0px !important;
}
.v-list-item.theme--light {
  padding-left: 0px !important;
}

.v-card__subtitle,
.v-card__text,
.v-card__title {
  padding: 0;
}

.v-card {
  overflow-wrap: inherit;
  white-space: pre;
}
</style>